// News items for the top banner list
import i18n from '@/lang';
import { newIndexNewsImages, newIndexSpotImages, newIndexVrImages, newIndexSloganBannerImage } from '@/data/newIndexAssets.js';

const VR_MOCK_LINK = 'https://www.720yun.com/vr/b34jtgtfvk7';

export const newsList = [
  {
    id: '122',
    title: '青岛市委宣传部开展走访慰问道德模范和身边好人活动',
    imageUrl: newIndexNewsImages.harborNight,
  },
  {
    id: '122',
    title: '青岛西海岸新区牵手北京"猎云网"共筑北方OPC产业新高地',
    imageUrl: newIndexNewsImages.coastSunset,
  },
  {
    id: '122',
    title: '青岛西海岸新区：数字赋能，重塑政务服务边界',
    imageUrl: newIndexNewsImages.bridgeSunset,
  },
  {
    id: '122',
    title: '"智享新春 科惠未来"2026科普伴您过大年活动开启',
    imageUrl: newIndexNewsImages.harborNight,
  },
  {
    id: '122',
    title: '青岛市委宣传部开展走访慰问道德模范和身边好人活动',
    imageUrl: newIndexNewsImages.coastSunset,
  },
];

// Spot cards for the "山海名城 活力青岛" section

export const spotCards = [
  {
    id: '138',
    title: '青岛故事简介',
    imageUrl: newIndexSpotImages.story,
    href: '/tale_detail?id=138',
  },
  {
    id: '138',
    title: '青岛超有YOUNG简介',
    imageUrl: newIndexSpotImages.young,
    href: '/tale_detail?id=138',
  },
  {
    id: '138',
    title: '全民阅读简介',
    imageUrl: newIndexSpotImages.reading,
    href: '/tale_detail?id=138',
  },
  {
    id: '138',
    title: '青年榜YOUNG简介',
    imageUrl: newIndexSpotImages.youthRank,
    href: '/tale_detail?id=138',
  },
];

// International Communication lists (world-in-qd, qd-in-world)
export const internationalItems = [
  {
    id: "int-1",
    title: "荣耀启航 共话精彩",
    category: "世界在青岛",
    date: "2025-02-12",
    imageUrl: "https://images.unsplash.com/photo-1516690553959-71a414d6b9b6?auto=format&fit=crop&w=600&h=400&q=80",
    summary: "2025-26克利伯环球帆船赛青岛站媒体见面会圆满举办，吸引了来自英国、挪威、澳大利亚、加拿大等十多个国家的近百名国际船员，一同讲好青岛‘红瓦绿树，帆船之都’的璀璨海上交响故事。"
  },
  {
    id: "int-2",
    title: "风帆为媒 山海相约",
    category: "世界在青岛",
    date: "2025-02-15",
    imageUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&h=400&q=80",
    summary: "2025-26克利伯环球帆船赛青岛站颁奖仪式盛大举行。在五四广场、金色浮山湾畔，国际探险者们共同举杯分享征服风浪的光辉时刻，向全世界展示了青岛的包容与国际赛事水准。"
  },
  {
    id: "int-3",
    title: "当啤酒节遇上跨国企业领袖",
    category: "世界在青岛",
    date: "2025-08-18",
    imageUrl: "https://images.unsplash.com/photo-1532635241-17e820add50f?auto=format&fit=crop&w=600&h=400&q=80",
    summary: "在金沙滩啤酒城，来自德同、西门子等三十余家欧美国际企业的驻华高管与地方创业代表，体验最地道的青岛精酿，开展了一场融汇文化与产业协作的‘啤酒社交’，共叙发展红利。"
  },
  {
    id: "int-4",
    title: "青岛海洋高端制造走出国门",
    category: "青岛在世界",
    date: "2025-11-05",
    imageUrl: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=600&h=400&q=80",
    summary: "青岛造深海采收及钻井配套设施正式装船运往北欧北海石油开采地，展示了‘青岛智造’在高等级钻机、防砂除砂核心部件以及在超深海勘探装备上的顶尖实力与国际客户的高度肯定。"
  },
  {
    id: "int-5",
    title: "以茶结缘：崂山绿茶在法国巴黎香榭丽舍香飘四溢",
    category: "青岛在世界",
    date: "2025-10-14",
    imageUrl: "https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&h=400&q=80",
    summary: "青岛文旅代表团在新一届巴黎中法科技文化展上，设立‘崂山茶道韵味’专属展区。古朴精美的手制茶饼和行云流水的点茶技艺，折服了众多塞纳河畔的国际友人，成为中外文化交流的典范。"
  },
  {
    id: "int-6",
    title: "青岛交响乐团欧洲巡演：在维也纳金色大厅奏响东方风骨",
    category: "青岛在世界",
    date: "2025-09-28",
    imageUrl: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=600&h=400&q=80",
    summary: "由青岛交响乐团担纲演出的‘山海乐声：海洋之心’巡回演奏会，在奥地利圆满落幕。中西合璧的协奏曲以及改编的胶东大秧歌乐段，斩获全场长达十分钟的热烈起立鼓掌。"
  }
];

// Photo Depot Data representing standard showcase and multi-category bento grid
export const photoItems = [
  {
    id: "photo-1",
    title: "栈桥回澜阁晨光",
    category: "自然风光",
    author: "李晨",
    imageUrl: "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9?auto=format&fit=crop&w=800&q=80",
    likes: 1243,
    camera: "Sony Alpha 7R V",
    lens: "FE 24-70mm F2.8 GM II",
    exposure: "1/120s · f/8 · ISO 100"
  },
  {
    id: "photo-2",
    title: "浮山湾璀璨都市天际线",
    category: "城市风光",
    author: "张伟",
    imageUrl: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=800&q=80",
    likes: 3102,
    camera: "Fujifilm GFX 100S",
    lens: "GF 32-64mm F4 R LM WR",
    exposure: "2.5s · f/11 · ISO 100"
  },
  {
    id: "photo-3",
    title: "奥帆中心：风起帆洋逐浪高",
    category: "推荐",
    author: "王晓帆",
    imageUrl: "https://images.unsplash.com/photo-1516690553959-71a414d6b9b6?auto=format&fit=crop&w=800&q=80",
    likes: 4521,
    camera: "Canon EOS R5",
    lens: "RF 70-200mm F2.8 L IS USM",
    exposure: "1/1000s · f/4 · ISO 200"
  },
  {
    id: "photo-4",
    title: "跨海大桥宛如卧龙卧波",
    category: "自然风光",
    author: "周海",
    imageUrl: "https://images.unsplash.com/photo-1504297050568-910d24c426d3?auto=format&fit=crop&w=800&q=80",
    likes: 1890,
    camera: "Nikon Z7 II",
    lens: "NIKKOR Z 24-120mm f/4 S",
    exposure: "1/250s · f/5.6 · ISO 64"
  },
  {
    id: "photo-5",
    title: "红顶白墙的圣弥额尔大教堂",
    category: "城市风光",
    author: "赵敏",
    imageUrl: "https://images.unsplash.com/photo-1548625361-155de6c7f54d?auto=format&fit=crop&w=800&q=80",
    likes: 2155,
    camera: "Leica M11",
    lens: "Summilux-M 35mm f/1.4 ASPH",
    exposure: "1/180s · f/5.6 · ISO 200"
  },
  {
    id: "photo-6",
    title: "上合组织青岛峰会主场馆会客日",
    category: "国际交流",
    author: "陈明国",
    imageUrl: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80",
    likes: 832,
    camera: "Sony Alpha 7R IV",
    lens: "FE 16-35mm F2.8 GM",
    exposure: "1/60s · f/4 · ISO 400"
  },
  {
    id: "photo-7",
    title: "青岛国际啤酒节狂欢夜巡游",
    category: "节会活动",
    author: "韩雪",
    imageUrl: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=800&q=80",
    likes: 1420,
    camera: "Sony Alpha 7S III",
    lens: "FE 50mm F1.2 GM",
    exposure: "1/125s · f/1.2 · ISO 1600"
  },
  {
    id: "photo-8",
    title: "智能制造：西海岸全自动化集装箱码头",
    category: "经济发展",
    author: "刘洋",
    imageUrl: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=800&q=80",
    likes: 1109,
    camera: "DJI Mavic 3 Pro",
    lens: "Standard Hasselblad Camera",
    exposure: "1/500s · f/4 · ISO 100"
  },
  {
    id: "photo-9",
    title: "深秋金黄下的八大关公主楼落叶",
    category: "文化体育",
    author: "吴雨涵",
    imageUrl: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
    likes: 1673,
    camera: "Canon EOS R6 Mark II",
    lens: "RF 85mm F1.2 L USM",
    exposure: "1/400s · f/1.2 · ISO 100"
  },
  {
    id: "photo-10",
    title: "五四广场五月的风夜晚赤红",
    category: "推荐",
    author: "孙健",
    imageUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80",
    likes: 3882,
    camera: "Sony Alpha 7R V",
    lens: "FE 16-35mm F2.8 GM II",
    exposure: "1.6s · f/8 · ISO 100"
  },
  {
    id: "photo-11",
    title: "青岛海洋科技馆：深地质层模拟",
    category: "推荐",
    author: "董科",
    imageUrl: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80",
    likes: 1294,
    camera: "Sony Alpha 1",
    lens: "FE 24-70mm F2.8 GM II",
    exposure: "1/80s · f/4 · ISO 400"
  },
  {
    id: "photo-12",
    title: "崂山九水十八潭之翡翠幽谷",
    category: "推荐",
    author: "徐松",
    imageUrl: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=800&q=80",
    likes: 2933,
    camera: "Canon EOS R5",
    lens: "RF 15-35mm F2.8 L IS USM",
    exposure: "0.5s · f/11 · ISO 100"
  },
  {
    id: "photo-13",
    title: "胶州湾大桥云海奇观",
    category: "自然风光",
    author: "许国光",
    imageUrl: "https://images.unsplash.com/photo-1449034446853-66c86144b0ad?auto=format&fit=crop&w=800&q=80",
    likes: 3021,
    camera: "Nikon Z9",
    lens: "NIKKOR Z 70-200mm f/2.8 VR S",
    exposure: "1/500s · f/8 · ISO 64"
  },
  {
    id: "photo-14",
    title: "中国海洋大学崂山校区樱花大道",
    category: "文化体育",
    author: "陆一民",
    imageUrl: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80",
    likes: 1954,
    camera: "Fujifilm X-T5",
    lens: "XF 56mm F1.2 R WR",
    exposure: "1/200s · f/1.2 · ISO 125"
  },
  {
    id: "photo-15",
    title: "金沙滩蔚蓝帆船运动赛",
    category: "推荐",
    author: "钟华",
    imageUrl: "https://images.unsplash.com/photo-1548625361-155de6c7f54d?auto=format&fit=crop&w=800&q=80",
    likes: 2603,
    camera: "Canon EOS R3",
    lens: "RF 400mm F2.8 L IS USM",
    exposure: "1/2000s · f/4 · ISO 400"
  },
  {
    id: "photo-16",
    title: "青岛历史老街里院的文艺转角",
    category: "城市风光",
    author: "高晓峰",
    imageUrl: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
    likes: 1759,
    camera: "Leica Q3",
    lens: "Summilux 28mm f/1.7 ASPH",
    exposure: "1/125s · f/2.8 · ISO 100"
  },
  {
    id: "photo-17",
    title: "胶东半岛红顶欧式德式经典别墅群",
    category: "影像档案",
    author: "王博",
    imageUrl: "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?auto=format&fit=crop&w=800&q=80",
    likes: 2154,
    camera: "Nikon Z7 II",
    lens: "NIKKOR Z 24-70mm f/2.8 S",
    exposure: "1/100s · f/5.6 · ISO 64"
  },
  {
    id: "photo-18",
    title: "克利伯帆船国际船员欢呼起航",
    category: "国际交流",
    author: "麦克·大卫",
    imageUrl: "https://images.unsplash.com/photo-1516690553959-71a414d6b9b6?auto=format&fit=crop&w=800&q=80",
    likes: 1475,
    camera: "Sony Alpha 7R V",
    lens: "FE 70-200mm F4 Macro G OSS II",
    exposure: "1/800s · f/5.6 · ISO 200"
  },
  {
    id: "photo-19",
    title: "高清数字航拍崂山云雾金滩",
    category: "高清视频素材",
    author: "谢飞",
    imageUrl: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
    likes: 3105,
    camera: "DJI Inspire 3",
    lens: "DL 18mm F2.8 ASPH",
    exposure: "1/240s · f/4 · ISO 100"
  }
];

// Video lists with immersive background themes for "视觉青岛" API
export const visualVideos = [
  {
    id: "v-1",
    title: "仙山路立交桥",
    description: "夜色之下，纵横交错的立交桥犹如流淌的光影丝带，彰显着城市智慧交通的雄浑张力。极具现代感的线条将青岛的东西两翼无缝相连，呈现科幻般的流金夜景。",
    imageUrl: "https://images.unsplash.com/photo-1504297050568-910d24c426d3?auto=format&fit=crop&w=1200&h=700&q=80",
    themeColor: "from-blue-900/90 to-indigo-950/90"
  },
  {
    id: "v-2",
    title: "秋韵八大关",
    description: "落叶不扫，浪漫至极。这里有万国建筑的大融合，在枫红、杏黄与海蓝的交响乐中步入童话。公主楼深红、花石楼葱茏，红树与碧海在晨光里握手相拥。",
    imageUrl: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&h=700&q=80",
    themeColor: "from-amber-900/90 to-orange-950/90"
  },
  {
    id: "v-3",
    title: "崂山金家岭",
    description: "海上第一名山脚下的金融巨轮，背靠崂山灵翠之峰，面朝波澜壮阔的黄海。财富高地与生态绿洲完美合璧，白日白鹭齐飞，晚上金融城霓虹璀璨。",
    imageUrl: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1200&h=700&q=80",
    themeColor: "from-emerald-900/90 to-teal-950/90"
  },
  {
    id: "v-4",
    title: "百年老城区",
    description: "漫步在坡道蜿蜒的大学路，斑驳的红墙外斜印着法桐树影。历史里凝缩着风情，这里的百座里院旧貌胜新颜，咖啡微醺、手作温润，古典里浸透着最青春的文艺分子。",
    imageUrl: "https://images.unsplash.com/photo-1449034446853-66c86144b0ad?auto=format&fit=crop&w=1200&h=700&q=80",
    themeColor: "from-zinc-900/90 to-slate-950/90"
  },
  {
    id: "v-5",
    title: "静谧港湾",
    description: "入夜的金沙滩港湾波光如织，游艇与帆船随着晚风微澜轻轻摇曳。晚霞在天际燃烧，又被深邃的深蓝色洋面拥入怀中，静坐在码头听远方船笛低回，是一天里最安适的时刻。",
    imageUrl: "https://images.unsplash.com/photo-1505228395891-9a51e7e86be6?auto=format&fit=crop&w=1200&h=700&q=80",
    themeColor: "from-cyan-950/90 to-sky-950/90"
  }
];

// VR Exhibition Items
export const vrList = [
  {
    id: 'vr-1',
    title: '黄河从草原上流过——内蒙古黄河流域',
    imageUrl: newIndexVrImages.vr1,
    href: VR_MOCK_LINK,
  },
  {
    id: 'vr-2',
    title: '青岛市博物馆',
    imageUrl: newIndexVrImages.vr2,
    href: VR_MOCK_LINK,
  },
  {
    id: 'vr-3',
    title: '青岛德国总督楼旧址博物馆（青岛迎宾馆）',
    imageUrl: newIndexVrImages.vr3,
    href: VR_MOCK_LINK,
  },
  {
    id: 'vr-4',
    title: '只此敦煌——敦煌石窟艺术展',
    imageUrl: newIndexVrImages.vr4,
    href: VR_MOCK_LINK,
  },
  {
    id: 'vr-5',
    title: '极目楚天舒——楚文化特展',
    imageUrl: newIndexVrImages.vr5,
    href: VR_MOCK_LINK,
  },
  {
    id: 'vr-6',
    title: '山海故人—青岛文化名人展',
    imageUrl: newIndexVrImages.vr6,
    href: VR_MOCK_LINK,
  },
];

// Legacy export name kept for compatibility
export const vrExhibitions = vrList;

// Service Items with detail FAQ support
export const serviceItems = [
  {
    id: "srv-1",
    title: "12366税务服务",
    subTitle: "在线咨询与解答",
    details: "为来青外籍投资人及创业企业提供双语税务政策讲解。服务范围涵盖个人所得税年度汇算清缴、跨国交易避免双重征税协定解释、在青创办高新技术企业的专项减免税等热点领域。",
    redirectUrl: "https://12366.chinatax.gov.cn/",
    faqList: [
      { q: "在青岛创办跨境高新技术企业有哪些所得税补贴？", a: "经认定的国家高新技术企业享15%个人或企业所得税优惠，地方政府另有最高50万元研发开办券补贴。" },
      { q: "外国人才个人所得税专项扣除包含哪些，如何申报？", a: "包括在华住房租金、子女教育折抵津贴与语言学习费。可通过‘个人所得税’App直接无纸化一键登记申报。" }
    ]
  },
  {
    id: "srv-2",
    title: "海外人员居住登记",
    subTitle: "临宿登记及电子证明",
    details: "凡入境来青居住于亲友家、租赁住房或其他非登记宾馆的外商或探亲外国人士，必须在抵达24小时内向居住地派出所进行临宿登记。本项服务支持网上预先提交 and 进度催办。",
    redirectUrl: "https://s.nia.gov.cn/",
    faqList: [
      { q: "外国人临时来青访友，必须去线下派出所登记吗？", a: "推荐直接在本平台‘临宿速办’小程序提交护照签证页 and 房主身份证，足不出户生成电子《境外人员临时住宿登记表》。" },
      { q: "超过24小时未登记有什么法律后果？", a: "根据《出境入境管理法》，未依规登记将处以警告或单处/并处最高2000元人民币罚款，因此请您务必及时自助在线补办。" }
    ]
  },
  {
    id: "srv-3",
    title: "在线查看外国人",
    subTitle: "申请状态和审批进度",
    details: "为外籍及港澳台常驻青岛雇员提供实时的在青居留许可、工作签证、出入境加急审批状态自助联查，关联政府办事系统，透明跟进每一份手续动态。",
    redirectUrl: "https://s.nia.gov.cn/",
    faqList: [
      { q: "为什么我的工作许可证审批一直显示'审核中'？", a: "通常是由于用人企业提交的海外无犯罪记录未进行领事公证认证，您可在后台查看补录退回明细并重新在线补交。" },
      { q: "怎么获取审批成功的电子版随行人员常驻通知指引？", a: "登录后在‘我的申请’详情页，可在签证批准的第一时间免费下载带数字盖章的中英双语《常驻出入境受理指引》。" }
    ]
  },
  {
    id: "srv-4",
    title: "进展查询",
    subTitle: "关于外国人的作品及许可",
    details: "针对在青外籍艺术家、工业设计师以及内容学者在本地发表的摄影、动漫、技术发明以及著作权、出版发行的行政合规申报及正规版税/作品登记发放进度提供官方通道查询。",
    redirectUrl: "http://qd.zwfw.sd.gov.cn/",
    faqList: [
      { q: "在青外籍创作者注册作品著作权有哪些便利政策？", a: "免收外国文书驻外使馆认证费，仅需提交护照翻译套件可在线绿色通道优先快办，整体周期较往年缩短了一半。" },
      { q: "登记外籍导演在胶东湾微电影创作许可证如何查询？", a: "点击本服务分类‘文化许可专题’，录入制片机构许可证代码，可秒查影片初审与最终放映标志批准字号。" }
    ]
  },
  {
    id: "srv-5",
    title: "首次申请居住学生许可",
    subTitle: "留学一站式申请及加签",
    details: "面向中国海洋大学、青岛大学等名校的外籍来青留学生，提供入学后首张学签及居留许可的在线校审、体检预约指南、公安局出入境大厅材料审核以及免原件闪办业务。",
    redirectUrl: "https://s.nia.gov.cn/",
    faqList: [
      { q: "首次来青留学入境后口岸落地签如何置换为长期学习许可证？", a: "需凭校方录取通知书（JW201/202表）及健康证明，在入境30日内提交本系统进行线上预审，通过后前往市局出入境大厅一次面签取件。" },
      { q: "留学生可否在青岛本地申请勤工俭学或实习许可置换？", a: "可以。具有青岛高校推荐信及雇主实习协议并在本系统备案的，可免费在居留许可上加注‘实习’字样开展课外实习工作。" }
    ]
  },
  {
    id: "srv-6",
    title: "扩展居留许可",
    subTitle: "外国人延期与类型变更",
    details: "主要包含由于工作续约、投资加注、家庭团聚需要而面临居留许可证到期前延期、多次往返加签、探亲许可（Q1/Q2型）向常驻工作许可（Z型）类型无冲突变更办理通道。",
    redirectUrl: "https://s.nia.gov.cn/",
    faqList: [
      { q: "工作居住许可证到期了，最晚需要提前多久申请延期？", a: "按照法律规定，您必须在当前居留许可到期前至少30日内，提交延期申请，逾期将自动被视为非法逾期滞留。" },
      { q: "因探亲由海外入境，临时在青找到用人单位如何转工作延期？", a: "需先在线申请‘工作前置人才评价单’，拿到后可一并提交探亲签证转工作类居留许可延期申请，无需离境重新办证。" }
    ]
  },
  {
    id: "srv-7",
    title: "护照更改（居留许可）",
    subTitle: "信息更新登记及补领",
    details: "当在青常住的外籍友人因新发护照换发、原护照损毁遗失、或婚姻改姓导致核心护照号及拼写信息变化时，必须在10日内办理出入境居留证件信息同步变更，确保在华征信和签证资质畅通无阻。",
    redirectUrl: "https://s.nia.gov.cn/",
    faqList: [
      { q: "刚在驻华使馆换了新护照，原居留卡还在老护照上，能照常出行吗？", a: "不能，两国护照号不同将导致口岸受阻。您须在本系统提交异动变更，并在10天内去出入境换发新一期关联居留贴花。" },
      { q: "在青岛遗失护照如何加急办理‘异动销案’并补办？", a: "立刻在线报失并获取《遗失报警受理回执》，我局出入境加急窗口将在3个工作日内签发离境或补办用签证件，全力维持出行。" }
    ]
  },
  {
    id: "srv-8",
    title: "地址变更居住许可",
    subTitle: "跨区搬家备案、全国购服务",
    details: "为避免外籍居民在青岛本市搬迁跨区（如市南搬往崂山），或长期旅居异地产生未备案涉法处罚，保障外国友人在中国生活消费保障、退税与社商保险异地赔付核实。",
    redirectUrl: "https://s.nia.gov.cn/",
    faqList: [
      { q: "在青岛市内搬家，是否需要更改拘留许可证上的备案地址？", a: "需要。必须在新地址落户10日内，通过本系统‘一键搬家申报’填报新房产证明，系统后台会自动重置出入境局档案信息。" },
      { q: "本省异地异区购房及出入境联动登记要提供额外公证吗？", a: "不需要，仅需上传网签购房合同电子复印件与本局备案号，系统自动比对国土交易库，实现线上免公证直接异地地址挂网变更。" }
    ]
  }
];

export const sloganScenes = [
  {
    id: 'qingdao-slogan',
    imageUrl: newIndexSloganBannerImage,
    subSlogan: '',
    url: '',
  },
];

export function getWorldInQingdaoItems() {
  const t = i18n.global.t;
  const itemMeta = [
    { id: 'int-1', imageUrl: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=600&h=450&q=80', date: '2025-02-12', videoDuration: '02:45' },
    { id: 'int-2', imageUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&h=450&q=80', date: '2025-02-15', videoDuration: '03:10' },
    { id: 'int-3', imageUrl: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=600&h=450&q=80', date: '2025-08-16', videoDuration: '01:58' },
  ];

  return itemMeta.map(({ id, imageUrl, date, videoDuration }) => ({
    id,
    tag: t(`newIndex.sections.intComm.items.${id}.tag`),
    title: t(`newIndex.sections.intComm.items.${id}.title`),
    summary: t(`newIndex.sections.intComm.items.${id}.summary`),
    imageUrl,
    date,
    videoDuration,
  }));
}

export function getQingdaoInWorldItems() {
  const t = i18n.global.t;
  const itemMeta = [
    { id: 'int-4', imageUrl: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=600&h=450&q=80', date: '2025-11-05', videoDuration: '02:15' },
    { id: 'int-5', imageUrl: 'https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=600&h=450&q=80', date: '2025-09-28', videoDuration: '04:30' },
    { id: 'int-6', imageUrl: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&h=450&q=80', date: '2025-10-14', videoDuration: '03:50' },
  ];

  return itemMeta.map(({ id, imageUrl, date, videoDuration }) => ({
    id,
    tag: t(`newIndex.sections.intComm.items.${id}.tag`),
    title: t(`newIndex.sections.intComm.items.${id}.title`),
    summary: t(`newIndex.sections.intComm.items.${id}.summary`),
    imageUrl,
    date,
    videoDuration,
  }));
}

export function getVrList() {
  return vrList;
}
